import {useQuery} from "@tanstack/react-query";
import client from '../../utils/Client'
import { normalizePaged } from "../../utils/helpers";




// GET ALL PROFILED USERS
// --- existing (kept as-is for any places that still need the full array) ---
const profiledUsers = (pageNumber = 1, pageSize = 20) =>
  client.get(`auth/profiledUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const useGetProfiledUsers = (pageNumber = 1, pageSize = 100) =>
  useQuery(
    ["profiledUsers", pageNumber, pageSize],
    () => profiledUsers(pageNumber, pageSize),
    { select: (res) => res?.data?.result, refetchInterval: 60_000 }
  );

// VERIFY USER
const verifyUser = (userLogin) => client.get(`auth/user?userLogin=${userLogin}`);
export const useVerifyUser = (userLogin) => useQuery(['verifyUser',userLogin],() =>verifyUser(userLogin), {select: data => data?.data?.result,refetchInterval:60_000,enabled:false})

// GET ALL PRIVILEGES
const privileges = () => client.get('auth/privileges');
export const useGetPrivileges = () => useQuery(['privileges'],() =>privileges(), {select: data => data?.data?.result,refetchInterval:60_000})


// --- paged hook for tables ---
export const useGetProfiledUsersPaged = (pageNumber = 1, pageSize = 20) =>
  useQuery(
    ["profiledUsers-paged", pageNumber, pageSize],
    async () => {
      const { data } = await client.get(
        `auth/profiledUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    { keepPreviousData: true, refetchInterval: 60_000 }
  );

// --- server-side search (assumes an endpoint like this; adjust path/param names if needed) ---
const searchProfiledUsers = (params) =>
  client.get(`auth/profiledUsers/search`, { params });

export const useSearchProfiledUsers = (filters) =>
  useQuery(
    ["profiledUsers-search", filters],
    async () => {
      const { data } = await searchProfiledUsers(filters);
      return normalizePaged(
        data?.result ?? data,
        {
          pageNumber: filters?.PageNumber ?? 1,
          pageSize: filters?.PageSize ?? 20,
        }
      );
    },
    {
      enabled: !!filters,       // only run when we actually have search filters
      keepPreviousData: true,   // smooth page changes
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    }
  );